export default __webpack_public_path__ + "static/media/crew-05-bit.07da7b7e.svg";